import { Wrench, Battery, Disc, Key, Fuel, AlertTriangle, Truck } from "lucide-react";

export const SERVICE_TYPES = [
  { value: "tow", label: "Tow", icon: Truck },
  { value: "jumpstart", label: "Jumpstart", icon: Battery },
  { value: "tire", label: "Tire Change", icon: Disc },
  { value: "lockout", label: "Lockout", icon: Key },
  { value: "fuel", label: "Fuel Delivery", icon: Fuel },
  { value: "winch", label: "Accident / Recovery", icon: AlertTriangle },
];

export const PRIORITY_OPTIONS = [
  { value: "urgent", label: "Urgent" },
  { value: "normal", label: "Normal" },
  { value: "low", label: "Low" },
];

export const STATUS_FLOW = [
  { value: "pending", label: "Pending" },
  { value: "assigned", label: "Assigned" },
  { value: "accepted", label: "Accepted" },
  { value: "en_route", label: "En Route" },
  { value: "on_site", label: "On Site" },
  { value: "awaiting_partner_close", label: "Closing in Partner App" },
  { value: "completed", label: "Completed" },
];

export const STATUS_COLORS = {
  booked: { bg: "bg-indigo-100", text: "text-indigo-800", dot: "bg-indigo-500" },
  pending: { bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500" },
  assigned: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-500" },
  accepted: { bg: "bg-sky-100", text: "text-sky-800", dot: "bg-sky-500" },
  en_route: { bg: "bg-violet-100", text: "text-violet-800", dot: "bg-violet-500" },
  on_site: { bg: "bg-teal-100", text: "text-teal-800", dot: "bg-teal-500" },
  awaiting_partner_close: { bg: "bg-fuchsia-100", text: "text-fuchsia-800", dot: "bg-fuchsia-500" },
  completed: { bg: "bg-emerald-100", text: "text-emerald-800", dot: "bg-emerald-500" },
  cancelled: { bg: "bg-slate-100", text: "text-slate-700", dot: "bg-slate-400" },
};

export const PRIORITY_COLORS = {
  urgent: { bg: "bg-rose-100", text: "text-rose-700", border: "border-rose-300" },
  normal: { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200" },
  low: { bg: "bg-slate-50", text: "text-slate-500", border: "border-slate-200" },
};

export const TRUCK_STATUS_COLORS = {
  available: { bg: "bg-emerald-100", text: "text-emerald-700", dot: "bg-emerald-500" },
  busy: { bg: "bg-amber-100", text: "text-amber-700", dot: "bg-amber-500" },
  offline: { bg: "bg-slate-600", text: "text-white", dot: "bg-slate-400" },
};

export const SERVICE_LABEL = {
  tow: "Tow",
  jumpstart: "Jumpstart",
  tire: "Tire Change",
  lockout: "Lockout",
  fuel: "Fuel Delivery",
  winch: "Accident / Recovery",
};

export const STATUS_LABEL = {
  booked: "Tow Booked",
  pending: "Pending",
  assigned: "Assigned",
  accepted: "Accepted",
  en_route: "En Route",
  on_site: "On Site",
  awaiting_partner_close: "Closing in Partner App",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const DEFAULT_CENTER = [-41.2706, 173.284]; // Nelson, NZ (matches backend geocode bias)
